import AttachmentList from '@intercom/embercom-composer/components/attachment-list';
export default AttachmentList;
